<div class="items-emision-section">
  <div class="type-selector" role="tablist" aria-label="Tipos de ítems de emisión">
    <button
      *ngFor="let type of itemTypes"
      type="button"
      class="type-button"
      [class.is-active]="activeType() === type.codigo"
      (click)="selectType(type.codigo)">
      <span class="type-label">{{ type.label }}</span>
      <span class="type-count">{{ facade.countsByType()[type.codigo] || 0 }}</span>
    </button>
  </div>

  <div class="panel-header">
    <div class="panel-title">
      <h3>{{ activeTypeConfig().label }}</h3>
      <p class="text-sm text-muted">{{ activeTypeConfig().description }}</p>
      <p class="text-xs text-muted">
        Campos obligatorios: {{ activeRequiredLabels().join(', ') }}
      </p>
    </div>
    <div class="panel-meta">
      <span [ngClass]="['status-pill', 'status-' + activeStatus().tone]">
        {{ activeStatus().label }}
      </span>
      <div class="subtotal-pill">
        <span>Subtotal {{ activeTypeConfig().label }}</span>
        <strong>{{ activeSubtotal() | currencyFormat:'$' }}</strong>
      </div>
      <button
        pButton
        type="button"
        icon="pi pi-plus"
        label="Agregar ítem"
        class="p-button-sm"
        (click)="addItem()"
        [disabled]="readOnly">
      </button>
    </div>
  </div>

  <div class="panel-body">
    <app-items-aire-spot
      *ngIf="activeType() === 'AIRE_SPOT'"
      [readOnly]="readOnly">
    </app-items-aire-spot>

    <app-items-banner-web
      *ngIf="activeType() === 'WEB_BANNER'"
      [readOnly]="readOnly"
      [vigenciaDesde]="vigenciaDesde"
      [vigenciaHasta]="vigenciaHasta">
    </app-items-banner-web>

    <app-items-redes
      *ngIf="activeType() === 'REDES_PIEZA'"
      [readOnly]="readOnly">
    </app-items-redes>

    <app-items-publinotas
      *ngIf="activeType() === 'PUBLINOTA'"
      [readOnly]="readOnly">
    </app-items-publinotas>

    <app-items-cobertura
      *ngIf="activeType() === 'COBERTURA_EVENTO'"
      [readOnly]="readOnly">
    </app-items-cobertura>

    <app-items-pnt
      *ngIf="activeType() === 'PNT'"
      [readOnly]="readOnly">
    </app-items-pnt>
  </div>

  <div class="panel-footer">
    <span class="keyboard-hint">Enter avanza, Ctrl/Alt + Enter agrega fila, Esc cierra dropdown</span>
  </div>
</div>
